import { twMerge } from 'tailwind-merge';

const Container = ({ children, className, ...properties }) => (
    <div className={twMerge('m-auto px-10', className)} {...properties}>
        {children}
    </div>
);

export default Container;
